import { Action } from '@ngrx/store';

export const SET_VIEWPORT_WIDTH = '[Device] set width';
export const SET_VIEWPORT_HEIGHT = '[Device] set height';
export const SET_TYPE = '[Device] set type';
export const SET_ORIENTATION = '[Device] set orientation';
export const SET_IS_XS_ONLY = '[Device] set is xs only';
export const SET_IS_SM_ONLY = '[Device] set is sm only';
export const SET_IS_SM_UP = '[Device] set is ms up';
export const SET_IS_MD_ONLY = '[Device] set is md only';
export const SET_IS_MD_UP = '[Device] set is md up';
export const SET_IS_LG_ONLY = '[Device] set is lg only';
export const SET_IS_LG_UP = '[Device] set is lg up';
export const SET_IS_XL_UP = '[Device] set is xlg only';
export const SET_IS_TOUCH = '[Device] set is touch behavior';
export const SET_IS_IOS = '[Device] set is iOs operating system';
export const SET_IS_ANDROID = '[Device] set is Android operating system';

export class SetViewportWidth implements Action {
  readonly type = SET_VIEWPORT_WIDTH;
}

export class SetViewportHeight implements Action {
  readonly type = SET_VIEWPORT_HEIGHT;
}

export class SetType implements Action {
  readonly type = SET_TYPE;

  constructor(public payload: string) {}
}

export class SetOrientation implements Action {
  readonly type = SET_ORIENTATION;

  constructor(public payload: string) {}
}

export class SetisXsOnly implements Action {
  readonly type = SET_IS_XS_ONLY;

  constructor(public payload: number) {}
}

export class SetisSmOnly implements Action {
  readonly type = SET_IS_SM_ONLY;

  constructor(public payload: number) {}
}

export class SetIsSmUp implements Action {
  readonly type = SET_IS_SM_UP;

  constructor(public payload: number) {}
}

export class SetIsMdOnly implements Action {
  readonly type = SET_IS_MD_ONLY;

  constructor(public payload: number) {}
}

export class SetIsMdUp implements Action {
  readonly type = SET_IS_MD_UP;

  constructor(public payload: number) {}
}

export class SetIsLgOnly implements Action {
  readonly type = SET_IS_LG_ONLY;

  constructor(public payload: number) {}
}

export class SetIsLgUp implements Action {
  readonly type = SET_IS_LG_UP;

  constructor(public payload: number) {}
}

export class SetisXlUp implements Action {
  readonly type = SET_IS_XL_UP;

  constructor(public payload: number) {}
}
export class SetIsTouch implements Action {
  readonly type = SET_IS_TOUCH;

  constructor(public payload: number) {}
}
export class SetIsIos implements Action {
  readonly type = SET_IS_IOS;

  constructor(public payload: number) {}
}
export class SetIsAndroid implements Action {
  readonly type = SET_IS_ANDROID;

  constructor(public payload: number) {}
}

export type DeviceActions =
  | SetViewportWidth
  | SetViewportHeight
  | SetType
  | SetOrientation
  | SetisXsOnly
  | SetisSmOnly
  | SetIsSmUp
  | SetIsMdOnly
  | SetIsMdUp
  | SetIsLgOnly
  | SetIsLgUp
  | SetisXlUp
  | SetIsTouch
  | SetIsIos
  | SetIsAndroid;
